const n = (t = 0) => new Promise((e) => {
  document.addEventListener("mouseleave", () => {
    e(!0);
  });
});
export {
  n as default
};
